class PencilBar extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.closeBtn = this.querySelector("[data-close]");
    this.trigger = this.querySelector("[data-pencil-trigger]");
    this.messages = Array.from(this.querySelectorAll(".pencil-bar__message"));
    this.currentIndex = 0;
    this.rotationTimer = null;
    this.rotationInterval = 6000;
    this.pointerInside = false;
    this.focusInside = false;
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    this.handleClose = () => this.close();
    this.handleClick = (event) => this.handleTriggerClick(event);
    this.handlePointerEnter = () => {
      this.pointerInside = true;
      this.pauseSignupRotation();
    };
    this.handlePointerLeave = () => {
      this.pointerInside = false;
      this.resumeRotation();
    };
    this.handleFocusIn = () => {
      this.focusInside = true;
      this.pauseSignupRotation();
    };
    this.handleFocusOut = (event) => {
      this.focusInside = this.contains(event.relatedTarget);
      if (!this.focusInside) this.resumeRotation();
    };
    this.handleMotionChange = () => {
      this.pauseRotation();
      this.resumeRotation();
    };

    this.closeBtn?.addEventListener("click", this.handleClose);
    this.trigger?.addEventListener("click", this.handleClick);
    this.addEventListener("mouseenter", this.handlePointerEnter);
    this.addEventListener("mouseleave", this.handlePointerLeave);
    this.addEventListener("focusin", this.handleFocusIn);
    this.addEventListener("focusout", this.handleFocusOut);
    this.reducedMotion.addEventListener("change", this.handleMotionChange);
    this.resumeRotation();
  }

  disconnectedCallback() {
    this.pauseRotation();
    this.closeBtn?.removeEventListener("click", this.handleClose);
    this.trigger?.removeEventListener("click", this.handleClick);
    this.removeEventListener("mouseenter", this.handlePointerEnter);
    this.removeEventListener("mouseleave", this.handlePointerLeave);
    this.removeEventListener("focusin", this.handleFocusIn);
    this.removeEventListener("focusout", this.handleFocusOut);
    this.reducedMotion?.removeEventListener("change", this.handleMotionChange);
  }

  close() {
    this.pauseRotation();
    this.style.display = "none";
    document.dispatchEvent(new CustomEvent("pencilbar:hide"));
  }

  handleTriggerClick(event) {
    const formId = this.dataset.klaviyoFormId;

    if (!formId) {
      if (this.trigger?.getAttribute("href") === (this.dataset.newsletterTarget || "#footer-newsletter")) {
        event.preventDefault();
        this.focusNewsletter();
      }
      return;
    }

    event.preventDefault();
    this.openSignup(formId);
  }

  openSignup(formId) {
    try {
      if (window._klOnsite && typeof window._klOnsite.push == "function") {
        window._klOnsite.push(["openForm", formId]);
        return;
      }
    } catch {}

    this.focusNewsletter();
  }

  focusNewsletter() {
    const target = document.querySelector(this.dataset.newsletterTarget || "#footer-newsletter");
    const input = document.querySelector("[data-footer-newsletter-email]") || target?.querySelector('input[name="email"], input[type="email"]');

    if (target) {
      target.scrollIntoView({
        behavior: this.reducedMotion.matches ? "auto" : "smooth",
        block: "center",
      });
    }

    if (input) {
      window.setTimeout(() => input.focus({ preventScroll: true }), 250);
    }
  }

  isHolding() {
    return this.pointerInside || this.focusInside;
  }

  isSignupMessageActive() {
    const current = this.messages[this.currentIndex];
    return current && current.textContent.includes("15% OFF");
  }

  pauseSignupRotation() {
    if (this.isSignupMessageActive()) this.pauseRotation();
  }

  resumeRotation() {
    if (this.rotationTimer || this.messages.length < 2 || this.reducedMotion.matches) return;
    this.rotationTimer = window.setInterval(() => this.showNextMessage(), this.rotationInterval);
  }

  pauseRotation() {
    if (!this.rotationTimer) return;
    window.clearInterval(this.rotationTimer);
    this.rotationTimer = null;
  }

  showNextMessage() {
    const current = this.messages[this.currentIndex];
    this.currentIndex = (this.currentIndex + 1) % this.messages.length;
    const next = this.messages[this.currentIndex];

    current.classList.remove("is-active");
    current.classList.add("is-exiting");
    next.classList.add("is-active");

    window.setTimeout(() => current.classList.remove("is-exiting"), 800);

    if (this.isHolding()) this.pauseSignupRotation();
  }
}

if (!customElements.get("pencil-bar")) {
  customElements.define("pencil-bar", PencilBar);
}
